/** @file New-token form: a name (the agent's actor name) and its scopes, all four ticked by default. */
import { ALL_SCOPES } from '@pose2d/api/actor';
import type { Scope } from '@pose2d/api/types';
import type { Translate } from '@pose2d/i18n/types';
import { useState, type SubmitEvent } from 'react';
import { CheckList } from '../../ui-kit/CheckList';

/** Props of TokenCreateForm. */
export interface TokenCreateFormProps {
  t: Translate;
  busy: boolean;
  onCreate: (name: string, scopes: Scope[]) => void;
}

/** The name is trimmed; nothing is sent without a name and a scope (the Worker checks the name rule). */
export function TokenCreateForm({ t, busy, onCreate }: TokenCreateFormProps) {
  const [name, setName] = useState('');
  const [scopes, setScopes] = useState<string[]>([...ALL_SCOPES]);
  const onSubmit = (event: SubmitEvent<HTMLFormElement>): void => {
    event.preventDefault();
    const picked = ALL_SCOPES.filter((scope) => scopes.includes(scope));
    if (name.trim() !== '' && picked.length > 0) onCreate(name.trim(), picked);
  };
  return (
    <form className="token-create" onSubmit={onSubmit}>
      <label>{t('tokens.name')}<input value={name} placeholder={'claude-code'} onChange={(e) => { setName(e.target.value); }} /></label>
      <CheckList legend={t('tokens.scopes')} options={ALL_SCOPES} picked={scopes} onChange={setScopes} />
      <button type="submit" disabled={busy || scopes.length === 0}>{t('tokens.create')}</button>
    </form>
  );
}
